import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { Modal } from '../components/Modal.jsx';

export default function Currencies() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['currencies'], queryFn: () => api('/api/currencies') });
  const [editing, setEditing] = useState(null);
  const save = useMutation({
    mutationFn: p => p.code
      ? api(`/api/currencies/${p.code}`, { method: 'PATCH', body: p.data })
      : api('/api/currencies', { method: 'POST', body: p.data }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['currencies'] }); setEditing(null); },
  });
  return (
    <>
      <div className="page-header">
        <h1>{t('currencies.title')}</h1>
        <button className="btn btn-primary" onClick={() => setEditing({})}>{t('currencies.add')}</button>
      </div>
      <table className="table">
        <thead><tr><th>{t('currencies.code')}</th><th>{t('common.name')}</th><th>{t('currencies.symbol')}</th><th>{t('common.active')}</th><th></th></tr></thead>
        <tbody>
          {data?.currencies?.map(c => (
            <tr key={c.code}>
              <td><strong>{c.code}</strong></td><td>{c.name}</td><td>{c.symbol}</td>
              <td>{c.active ? t('common.yes') : t('common.no')}</td>
              <td><button className="btn btn-secondary btn-sm" onClick={() => setEditing(c)}>{t('common.edit')}</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {editing && (
        <Modal title={editing.code ? t('common.edit') : t('currencies.add')} onClose={() => setEditing(null)}>
          <CurrencyForm c={editing} onSave={d => save.mutate({ code: editing.code, data: d })} onClose={() => setEditing(null)} saving={save.isPending} />
        </Modal>
      )}
    </>
  );
}

function CurrencyForm({ c, onSave, onClose, saving }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    code: c.code || '', name: c.name || '', symbol: c.symbol || '', active: c.active ?? true,
  });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  return (
    <form onSubmit={e => { e.preventDefault(); const p = { ...form }; if (c.code) delete p.code; onSave(p); }}>
      {!c.code && <div className="field"><label>{t('currencies.code')}</label><input maxLength={3} required value={form.code} onChange={e => set('code', e.target.value.toUpperCase())} /></div>}
      <div className="field"><label>{t('common.name')}</label><input required value={form.name} onChange={e => set('name', e.target.value)} /></div>
      <div className="field"><label>{t('currencies.symbol')}</label><input required value={form.symbol} onChange={e => set('symbol', e.target.value)} /></div>
      <div className="field"><label><input type="checkbox" checked={form.active} onChange={e => set('active', e.target.checked)} /> {t('common.active')}</label></div>
      <div className="modal-actions">
        <button type="button" className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
        <button type="submit" className="btn btn-primary" disabled={saving}>{t('common.save')}</button>
      </div>
    </form>
  );
}
